
namespace Matrix.Workflow {

    export class WorkflowQueueItemDialogOptions {
        queueCode: string;
        queueName: string;
        formFields: Serenity.PropertyItem[];
    }

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class WorkflowQueueItemDialog extends SiteEntityDialog<WorkflowInstanceRow, WorkflowQueueItemDialogOptions> {
        protected getFormKey() { return WorkflowInstanceForm.formKey; }
        protected getIdProperty() { return WorkflowInstanceRow.idProperty; }
        protected getLocalTextPrefix() { return WorkflowInstanceRow.localTextPrefix; }
        protected getNameProperty() { return WorkflowInstanceRow.nameProperty; }
        protected getService() { return WorkflowInstanceService.baseUrl; }
        protected editable: boolean;

        protected form = new WorkflowInstanceForm(this.idPrefix);

        constructor(opt: WorkflowQueueItemDialogOptions) {
            super(opt);

            $(window).on('resize.' + this.uniqueName, () => this.arrange());
        }

        destroy() {
            $(window).off('.' + this.uniqueName);
            super.destroy();
        }

        protected arrange() {
            super.arrange();
            var availHeight = $(window).height() - 290;

            for (var editor of this.propertyGrid.get_editors()) {
                if (editor.element && editor.element.is('.s-DataGrid') && editor.element.closest('.tab-pane').children().children().children('.field').length == 1) {
                    editor.element.css('height', Math.max(150, availHeight) + 'px').trigger('layout');
                }
            }

        }

        protected updateInterface() {
            super.updateInterface();

            this.cloneButton.hide();
            this.deleteButton.hide();
            if (!this.editable)
                this.editButton.hide();

            this.toolbar.element.toggle(
                this.entity.StatusCode === "PENDING" || this.toolbar.element.find('.wf-action-button').length);

            var chat = this.byId('Chat').tryGetWidget(WorkflowInstanceChat);
            if (chat)
                chat.set_readOnly(this.isEditMode());
        }

        protected getLoadByIdRequest(id) {
            var req = super.getLoadByIdRequest(id) as WorkflowQueueRetrieveRequest;
            req.QueueCode = this.options.queueCode;
            return req;
            
        }

        protected getLoadByIdOptions(id, callback) {
            var opt = super.getLoadByIdOptions(id, callback);
            opt.service = WorkflowInstanceService.Methods.RetrieveQueue;
            return opt;
        }

        protected loadResponse(response: WorkflowQueueRetrieveResponse) {
            this.toolbar.element.find('.wf-action-button').remove();

            if (response.Actions && response.Actions.length && !response.Entity.CurrentAction) {
                var container = this.toolbar.element.find('.buttons-inner');
                for (var x of response.Actions)
                    this.createActionButton(container, x);
            }
            
            super.loadResponse(response);
        }

        protected createActionButton(container: JQuery, x: ClientFunctionTriggerRow) {
            this.toolbar["createButton"](container, {
                cssClass: 'wf-action-button wf-action-' + x.TriggerCode,
                title: x.ActionVerb,
                icon: x.Icon,
                disabled: !Q.isEmptyOrNull(x.Permission) && !Q.Authorization.hasPermission(x.Permission),
                onClick: () => {

                    ClientFunctionService.GetModel({
                        FunctionName: x.FunctionName,
                        TriggerCode: x.TriggerCode
                    },
                        model => {
                            var entity = Q.deepClone(this.entity);
                            entity["ActionCode"] = x.TriggerCode;

                            model.Icon = x.Icon;
                            model.Parameters = model.Parameters || [];
                            model.ActionCode = x.TriggerCode;
                            model.WorkflowInstanceId = this.entityId;

                            for (var p of model.Parameters) {
                                delete p.formCssClass;
                                delete p.cssClass;
                                if (p.defaultValue != null &&
                                    p.defaultValue.indexOf('{{') >= 0) {
                                    p.defaultValue = Q.microFormat(p.defaultValue, entity);
                                }
                            }

                            var dlg = new WorkflowQueueInvokeDialog(model);
                            if (!Q.any(model.Parameters, x => x.visible == null || x.visible)) {
                                dlg.invoke(() => {
                                    Serenity.SubDialogHelper.triggerDataChange(this);
                                    this.dialogClose();
                                });
                            }
                            else {
                                dlg.dialogOpen();
                                dlg.then = () => {
                                    Serenity.SubDialogHelper.triggerDataChange(this);
                                    dlg.destroy();
                                    this.dialogClose();
                                }
                            }
                        });

                    

                }
            });
        }

        protected updateTitle() {
            this.dialogTitle = this.options.queueName + " - View Item";
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            var workflow = WorkflowRow.getLookup().itemById[(this.entity || {}).WorkflowCode];

            if (!this.options.formFields) {
                this.propertyGrid.enumerateItems((item, editor) => {
                    if (WorkflowInstanceNamedFields[item.name]) {
                        if (workflow && workflow[item.name + "Name"]) {
                            editor.getGridField().show()
                                .find('label.caption').text(titleize(workflow[item.name + "Name"]));
                        }
                        else if (workflow) {
                            editor.getGridField().hide();
                        }
                    }
                });
            }

            if (this.byId('Properties').is('textarea'))
                Workflow.replaceWithJsonViewer(this.form.Properties.element, this.entity.Properties);

            this.form.Documents.workflowInstanceId = this.entityId;
            this.form.Tasks.workflowInstanceId = this.entityId;
            var chat = this.byId('Chat').tryGetWidget(WorkflowInstanceChat);
            if (chat)
                chat.workflowInstanceId = this.entityId;

            if (this.processParamsList && this.processParamsList.length) {
                for (var pp of this.processParamsList) {
                    var params = pp.params || [];
                    for (var p of params) {
                        if (p.defaultValue != null &&
                            p.defaultValue.indexOf('{{') >= 0) {
                            p.defaultValue = Q.microFormat(p.defaultValue, this.entity);
                        }
                    }
                    pp.then(params);
                }
                this.processParamsList = [];
                this.arrange();
            }

        }

        protected getPropertyItems() {
            var items = super.getPropertyItems();
            this.editable = false;
            if (this.options.formFields && this.options.formFields.length) {
                var other = items.filter(x => x.tab != "Details" && x.tab);
                items = [];

                for (var x of this.options.formFields) {
                    items.push(x);
                    if (x.updatable)
                        this.editable = true;
                }

                items.push({
                    name: 'Chat',
                    title: 'Notes',
                    editorType: 'Matrix.Workflow.WorkflowInstanceChat',
                    oneWay: true,
                    updatable: true,
                    cssClass: 'col-xs-12',
                    tab: 'Details'
                })

                for (var x of other)
                    items.push(x);
            }

            for (var item of items) {
                if (item.editorType == "Matrix.Data.DataReportViewer") {
                    item.editorParams["processParams"] = (params: Serenity.PropertyItem[], then: ((params: Serenity.PropertyItem[]) => void)) => {
                        this.processParamsList.push({
                            params: params,
                            then: then
                        });
                    }
                }
            }

            return WorkflowQueueItemDialog.sortByTabAndCategory(items);
        }

        private processParamsList: any[] = [];

        public static sortByTabAndCategory(items: Serenity.PropertyItem[]) {
            var tabCount = 0;
            var itemCount = 0;
            var tabOrder: Q.Dictionary<number> = {};
            var catOrder: Q.Dictionary<number> = {};

            for (var x of items)
            {
                var tab = x.tab;
                if (tabOrder[tab] == null)
                    tabOrder[tab] = tabCount++;

                var cat = tab + ":::" + Q.trimToEmpty(x.category);
                if (catOrder[cat] == null)
                    catOrder[cat] = catOrder.Count;

                (x as any).__origOrder = itemCount++;
            }

            var list = items.slice();
            list.sort((x, y) => {
                var tx = tabOrder[x.tab];
                var ty = tabOrder[y.tab];
                if (tx < ty)
                    return -1;
                if (tx > ty)
                    return 1;

                var cx = x.tab + ":::" + Q.trimToEmpty(x.category);
                var cy = y.tab + ":::" + Q.trimToEmpty(y.category);

                if (cx < cy)
                    return -1;
                if (cx > cy)
                    return 1;

                var ox = (x as any).__origOrder;
                var oy = (y as any).__origOrder;

                if (ox < oy)
                    return -1;
                if (ox > oy)
                    return 1;
                return 0;
            });

            for (var x of items)
                delete (x as any).__origOrder;

            return list;
        }
    }
}